import { useCallback, useRef } from 'react'
import { computeSampledLabels } from '../../charts/config'

const useChartZoomSampling = (buckets, containerWidth) => {
  const bucketsRef = useRef(buckets)
  const widthRef = useRef(containerWidth)
  bucketsRef.current = buckets
  widthRef.current = containerWidth

  return useCallback((ctx, { xaxis }) => {
    if (typeof xaxis?.min !== 'number' || typeof xaxis?.max !== 'number')
      return
    const range = { min: Math.floor(xaxis.min), max: Math.ceil(xaxis.max) }
    const opts = { containerWidth: widthRef.current, range }
    const newCategories = computeSampledLabels(bucketsRef.current, opts)
    // Pass updateSyncedCharts=false to avoid a feedback loop with paired charts on the same page.
    ctx?.updateOptions?.({ xaxis: { categories: newCategories } }, true, true, false)
  }, [])
}

export default useChartZoomSampling
